import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-addAssetExpense',
  templateUrl: './addAssetExpense.component.html',
  styleUrls: ['./addAssetExpense.component.scss'] 
})

export class AddAssetExpenseComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any; 
  addedFor:string="";
  selectedCoreName:string="";
  episodeID:number=0;
  coreID:number=0;
  formDialog: FormGroup; 
  incomeID:number=0;
  spinner:boolean=false;
  assetID:number=0;
  expenseID:number=0;
  type:number=0;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<AddAssetExpenseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
    
  }  
  
  ngOnInit(): void {     
    if(this.data.addedFor=="Asset"){
      this.addedFor="Asset";
      this.assetID=this.data.assetIDexpenseID;
    }
     if(this.data.addedFor=="Expense"){
      this.addedFor="Expense";
       this.expenseID=this.data.assetIDexpenseID;
    }
   this.selectedCoreName=this.data.selectedCoreName;
   this.episodeID = this.data.episodeID;
   this.coreID = this.data.coreID;
   this.type = this.data.type;
   let addincome = {};
   this.formDialog = new FormGroup(addincome);
   this.formDialog.addControl('title', this.formBuilder.control('', Validators.required));
   this.formDialog.addControl('amount', this.formBuilder.control('', Validators.required));
   this.formDialog.addControl('description', this.formBuilder.control(''));
   this.formDialog.addControl('classification', this.formBuilder.control('1', Validators.required));
   //this.formDialog.addControl('type', this.formBuilder.control('0', Validators.required));
    // 0- Coming from Resident
   if(this.type==0){
    this.formDialog.addControl('type', this.formBuilder.control('0', Validators.required));
   }
   // 1- Coming from spouse
   if(this.type>0){
    this.formDialog.addControl('type', this.formBuilder.control('1', Validators.required));
   }

   if(this.assetID>0){
    this.formDialog.get('title')?.setValue(this.data.assetData.title);
    this.formDialog.get('amount')?.setValue(this.data.assetData.amount); 
    this.formDialog.get('description')?.setValue(this.data.assetData.note);
    this.formDialog.get('classification')?.setValue((this.data.assetData.classification).toString());
    this.formDialog.get('type')?.setValue((this.data.assetData.assetBy).toString());
   }
    if(this.expenseID>0){
    this.formDialog.get('title')?.setValue(this.data.assetData.title);
    this.formDialog.get('amount')?.setValue(this.data.assetData.amount); 
    this.formDialog.get('description')?.setValue(this.data.assetData.note);
    this.formDialog.get('classification')?.setValue((this.data.assetData.classification).toString());
    this.formDialog.get('type')?.setValue((this.data.assetData.expenseBy).toString());
   }

  }
      

  addAsset(data:any) {
     var ReqModel = {
      episodeID:this.episodeID,
      coreID:this.coreID,
      title: data.title,
      description:data.description,
      amount: Number(data.amount),
      classification:Number(data.classification),
      assetID:this.assetID,
      assetBy:Number(data.type),//this.type,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser.UID,
      officeID:this.myOfficeID
    }   
    this.spinner=true;
    this.formDialog.markAsPristine();
    //return;
    this.coreService.addAssetForPDPMCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        if (this.responseHolder.data == true) {         
          this.dialogRef.close('Added');
         if(this.assetID==0){
          this.toastr.success('Asset added successfully.', '', {
            timeOut: 2000,
          });    
         } 
         if(this.assetID>0){
          this.toastr.success('Asset update successfully.', '', {
            timeOut: 2000,
          });    
         } 
        }else{
          this.spinner=false;
          this.toastr.warning('Error occurred.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.spinner=false;
      }
    });
  }

  addExpense(data:any) {
     var ReqModel = {
      episodeID:this.episodeID,
      coreID:this.coreID,
      title: data.title,
      description:data.description,
      amount: Number(data.amount),
      classification:Number(data.classification),
      expenseID:this.expenseID,
      expenseBy:Number(data.type),
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      userId: this.currentUser.UID,
      officeID:this.myOfficeID
    }
    this.spinner=true;
    this.formDialog.markAsPristine();
    //return;
    this.coreService.addExpenseForPDPMCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.spinner=false;
        if (this.responseHolder.data == true) {         
          this.dialogRef.close('Added');
         if(this.expenseID==0){
          this.toastr.success('Expense added successfully.', '', {
            timeOut: 2000,
          });  
         }   
         if(this.expenseID>0){
          this.toastr.success('Expense update successfully.', '', {
            timeOut: 2000,
          });  
         } 
        }else{
          this.spinner=false;
          this.toastr.warning('Error occurred.', '', {
            timeOut: 2000,
          });         
        }
      }else{
        this.spinner=false;
      }
    });
  }

  numberOnly(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;

    // Allow: Backspace, Tab, Delete, Left, Right arrows
    if ([8, 9, 46, 37, 39].includes(charCode)) {
      return true;
    }

    // Allow numbers (0-9)
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }

    // Allow decimal point (.)
    if (charCode === 46) {
      // Prevent more than one decimal point
      const inputValue = (event.target as HTMLInputElement).value;
      if (inputValue.includes('.')) {
        return false;
      }
      return true;
    }

    return false;
  }

   closeDialog(){
    this.formDialog.reset();
    this.dialogRef.close();
    //this.dialog.closeAll();
  }
    
}
